













































import { Component, Prop, Mixins } from "vue-property-decorator"
import QuestionMixins from "@/mixins/QuestionMixins"
import { NEGATIVE_RULE_FLAGS } from '@/constants/questionnaire_answer'

@Component
export default class QuestionGroupPreviewItem extends Mixins(QuestionMixins) {
  @Prop() readonly index!: number
  @Prop() readonly item!: Question

  negativeRuleFlags = NEGATIVE_RULE_FLAGS
}
